import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationService } from '../../services/AuthenticationService';
import { UserManagementApiService } from '../../services/UserManagementApiService';

@Component({ standalone:false,
  selector: 'app-customer-error',
  templateUrl: './customer-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./customer-error.component.scss']
})
export class CustomerErrorComponent implements OnInit {

  public brandImage!: string;
  public brandDisplayName!: string;
  public brandingData!: any;

  constructor(private authService:AuthenticationService, private umApiService: UserManagementApiService) { }

  ngOnInit() {

      this.brandingData = this.authService.brandingDataCache;
      if(this.brandingData){
        this.brandImage = this.umApiService.siteURL + '/branding/' + this.brandingData.brandingImageURL;
        this.brandDisplayName = this.brandingData.businessDisplayName;
      }
  }

  get cowImage(){
    return '../assets/images/others/cow-1501690.png';
  }
}
